export const environment = {
  production: true,
  environment_cloud: false,
  environment_desktop: false,
  environment_name: "prod",
  popup_source_auth: false,

  lighthouse_api_endpoint_base: 'https://lighthouse.fastenhealth.com/v1',

  //used to specify the api server that we're going to use (can be relative or absolute). Must not have trailing slash
  fasten_api_endpoint_base: '/api',
};
